import Splide from '@splidejs/splide';

export default class RewardsTableSlider {
  constructor(context) {
    this.rewardsTableSlider = context.querySelector('.splide');
    this.splideOpts = {
      arrows: false,
      lazyLoad: 'nearby',
      pagination: true,
      preloadPages: 3,
      gap: 24,
    };

    this.tierTableOpts = [
      // only displays on mobile scale
      [4, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
    ];

    const tierTable = new Splide(this.rewardsTableSlider, this.splideOpts);

    tierTable.mount();

    tierTable.on('mounted', function () {
      setSliderLayout(tierTable, this.tierTableOpts);
    });
  }

  sliderOptions = (span, space, indent, slider) => {
    // CSS Layout Grid Preset Values
    options = {
      cols: 4,
      gap: 16,
      margin: 24,
    };

    if (window.matchMedia('(min-width: 600px)').matches) {
      options = {
        cols: 12,
        gap: 24,
        margin: 32,
      };
    }

    if (window.matchMedia('(min-width: 1200px)').matches) {
      options = {
        cols: 16,
        gap: 24,
        margin: 32,
      };
    }

    // Get the width of the parent grid elm of the slider
    let sliderId = slider.root.id;
    let sliderElem = document.getElementById(sliderId);
    let gridWidth = sliderElem.closest('.grid').clientWidth;
    // The width of the grid gap per the preset options
    let gapWidth = options.gap;
    // Column width is the grid elm width, minus the grid gap times the number
    // of columns less one (b/c there are only gaps b/w cols) divided by the
    // preset number of columns for the breakpoint.
    let colWidth = (gridWidth - gapWidth * (options.cols - 1)) / options.cols;
    // The slideSpan argument is the number of columns to span
    let slideSpan = span;
    // Slide width is the column width by the qty columns to span, plus the
    // gap width times the slideSpan minus one, b/c there is one less gap per
    // number of columns (ie, four cols contain three gaps)
    let slideWidth = colWidth * slideSpan + gapWidth * (slideSpan - 1);

    // If the space argument is 0 use one gap value
    if (space == 0) {
      space = options.gap;
    } else {
      // If greater, it is a col count. For the next slide to begin on a column,
      // add one to the value, as each spacer column is wrapped by gaps
      space = colWidth * space + gapWidth * (space + 1);
    }

    // Set these options on the slider instance
    slider.options = {
      fixedWidth: slideWidth,
      gap: space,
    };

    // Set the indent on the whole slider
    if (indent > 0) {
      let sliderId = slider.root.id;
      let sliderElem = document.getElementById(sliderId);
      sliderElem.style.marginLeft = (colWidth + gapWidth) * indent + 'px';
      sliderElem.style.marginRight = (colWidth + gapWidth) * indent + 'px';
    } else {
      sliderElem.style.removeProperty('margin-left');
      sliderElem.style.removeProperty('margin-right');
    }
  };

  setSliderLayout = (elem, options) => {
    if (window.matchMedia('(max-width: 599px)').matches) {
      return sliderOptions(options[0][0], options[0][1], options[0][2], elem);
    }
    if (window.matchMedia('(min-width: 600px) and (max-width: 899px').matches) {
      return sliderOptions(options[1][0], options[1][1], options[1][2], elem);
    }
    if (window.matchMedia('(min-width: 900px) and (max-width: 1199px').matches) {
      return sliderOptions(options[2][0], options[2][1], options[2][2], elem);
    }
    if (window.matchMedia('(min-width: 1200px)').matches) {
      return sliderOptions(options[3][0], options[3][1], options[3][2], elem);
    }
  };
}
